import { take, call, put} from 'redux-saga/effects';
import {
	uploadDecodeTargetNew,
	successUploadDecodeTargetNew,
	failUploadDecodeTargetNew,
} from '../actions';
import superFetchObject from '../modules/superFetchObject';
import {getApiUrl} from "./index";

export function* handleUploadDecodeTargetNew() {
	while (true) {

		const action = yield take(`${uploadDecodeTargetNew}`);
		const formData = new FormData();
		action.payload.files.forEach((file,index)=>{
			formData.append('file'+index,file);
		});
		formData.append('SessionID',action.payload.SessionID);

		const {payload,err} = yield call(superFetchObject, {
			url: getApiUrl() + 'decode-upload/',
			data: formData
		});
		if (err || payload.state === 'NG' || payload.state === 'ERROR') {
			let errorType;
			let errorData = [];
			if(err || payload.state === 'ERROR'){
				errorType = "PROCESS_ERROR";
			}
			else if(payload.state === 'NG'){
				errorType = payload.errorType;
				errorData = payload.data;
			}
			yield put(failUploadDecodeTargetNew({errorType, errorData}));
			continue;
		}
		yield put(successUploadDecodeTargetNew(Object.assign({}, payload.data, {})));
	}
}



// WEBPACK FOOTER //
// ./src/sagas/upload-receipt-new.js